import { render, staticRenderFns } from "./ConversionFactorDetail.vue?vue&type=template&id=19182b75&scoped=true"
import script from "./ConversionFactorDetail.vue?vue&type=script&lang=js"
export * from "./ConversionFactorDetail.vue?vue&type=script&lang=js"
import style0 from "./ConversionFactorDetail.vue?vue&type=style&index=0&id=19182b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19182b75",
  null
  
)

export default component.exports